import { useMemo } from 'react';
import { InsurancePlan } from '../types';
import { getDynamicCurrency } from '@/util-conversion/currency';
import { PlanRadioButtonCopy } from '../components/pdp/plan-radio-group/plan-radio-button';

interface UseInsurancePlanCopyProps {
  insurancePlans?: InsurancePlan[];
  disableInsurancePlanSelection?: boolean;
  inSwapFlow?: boolean;
  selectedInsurancePlanId?: string;
}

interface UseInsurancePlanCopyResponse {
  insurancePlansCopy: PlanRadioButtonCopy[];
}

export default function useInsurancePlanCopy({
  insurancePlans,
  disableInsurancePlanSelection,
  inSwapFlow,
  selectedInsurancePlanId,
}: UseInsurancePlanCopyProps): UseInsurancePlanCopyResponse {
  const insurancePlansCopy: PlanRadioButtonCopy[] = useMemo(() => {
    if (!insurancePlans) return [];

    // Only render current plan if in swap flow
    const filteredInsurancePlans =
      inSwapFlow && selectedInsurancePlanId
        ? insurancePlans.filter(
            (insurancePlan) => insurancePlan.id === Number(selectedInsurancePlanId)
          )
        : insurancePlans;

    return filteredInsurancePlans.map((insurancePlan) => ({
      id: String(insurancePlan.id),
      name: insurancePlan.name,
      pricePerMonthCopy: `${getDynamicCurrency(insurancePlan.price_per_month)}/mo`,
      details: insurancePlan.details,
      tag: insurancePlan.is_recommended ? 'recommended' : undefined,
      disabled: disableInsurancePlanSelection,
      isSwap: inSwapFlow,
    }));
  }, [
    disableInsurancePlanSelection,
    inSwapFlow,
    insurancePlans,
    selectedInsurancePlanId,
  ]);

  return {
    insurancePlansCopy,
  };
}
